import { v1 as uuidv1 } from "uuid";

const setColors = (donutRing) => {
	// This function will return the start and end point for the donut gradients
	const colorCodes = {
		gray: {
			start: "#6E787F",
			end: "#C7CCCE"
		},
		teal: {
			start: "#038189",
			end: "#62E0C9"
		}
	};

	// This will grab the last classname and split off the last word - which should be the gradient color
	const donutColorChoice = donutRing.classList[1].split("-").at(-1);
	const donutColors = colorCodes[donutColorChoice];

	// Return the object with gradient start and end colors
	return donutColors;
};
const getPercentage = (donut: Element) => {
	const donutPercentInnerText = donut.querySelector(".animated-donut-inner-text-percentage");
	return Number(
		donutPercentInnerText && donutPercentInnerText.textContent
			? donutPercentInnerText.textContent.slice(0, -1)
			: 0
	);
};
export const animateDonuts = (entry: IntersectionObserverEntry["target"]) => {
	// Grab all the elements we need to animate or use to detemine the animation
	const titles = entry.querySelectorAll(".animated-donut-title");
	const innerTexts = entry.querySelectorAll(".animated-donut-inner-text");
	const description =
		entry.querySelector(".animated-donut-xs-description-forced") ||
		entry.querySelector(".animated-donut-xs-description");
	const donuts = entry.querySelectorAll(".animated-donut");
	// Grab all the percentages and calculate the max value that will animate for the whole duration
	// Example; [0, 17, 81], duration: 1000ms. mMx value is 81, 81% will animate the full 1000ms
	const allDonutsPercentages = [...donuts].map((d) => getPercentage(d));
	const maxPercent = Math.max(...allDonutsPercentages);

	donuts.forEach((donut) => {
		const donutWithRing = donut.querySelector<HTMLElement>(".animated-donut-percent");
		if (donutWithRing) {
			// Grab colors by sending to our setColors function
			const donutRingColors = setColors(donutWithRing);
			// Create css var that will be used in the animation
			const donutPercentNumber = getPercentage(donut);
			const uniqueId = uuidv1();
			try {
				window.CSS.registerProperty({
					name: `--donut-percent-${uniqueId}`,
					syntax: "<percentage>",
					inherits: false,
					initialValue: "0%"
				});
			} catch (e) {
				console.error(e);
			}
			donutWithRing.style.background = `conic-gradient(from 0deg, ${donutRingColors.start} 0%, ${donutRingColors.end} var(--donut-percent-${uniqueId}), #00000000 var(--donut-percent-${uniqueId})`;
			// Create animation Options for each donut
			const animationOptionsDictionary = {
				"animated-donut-cards": { duration: 1600, delay: 800 },
				"ddiff-animated-donuts": { duration: 1000, delay: 600 }
			};
			const animationProps =
				animationOptionsDictionary[entry.classList[entry.classList.length - 1]];
			const duration = (donutPercentNumber / maxPercent) * animationProps.duration;
			donutWithRing.animate(
				[
					{ [`--donut-percent-${uniqueId}`]: "0%" },
					{ [`--donut-percent-${uniqueId}`]: `${donutPercentNumber}%` }
				],
				{
					duration: duration,
					fill: "forwards",
					easing: "cubic-bezier(0.37, 0, 0.63, 1)",
					delay: animationProps.delay
				}
			);
		} else {
			const donutCardImageCover = donut.querySelector(".animated-donut-image-cover");
			if (donutCardImageCover)
				donutCardImageCover.classList.add("animated-donut-image-cover-animate");
		}
	});
	// Animate all the required elements
	titles.forEach((title) => title.classList.add("animated-donut-title-animate"));
	innerTexts.forEach((text) => text.classList.add("animated-donut-inner-text-animate"));
	if (description) description.classList.add("animated-donut-xs-description-animate");
};

export const showDonutsContent = () => {
	const donutsContainer = document.querySelectorAll(".animated-donuts");
	if (donutsContainer.length) {
		donutsContainer.forEach((donutContainer) => {
			// We also need to handle the static version with js to know colors / percentage
			const donuts = donutContainer.querySelectorAll<HTMLElement>(".animated-donut");
			donuts.forEach((donut) => {
				const donutWithRing = donut.querySelector<HTMLElement>(".animated-donut-percent");
				if (donutWithRing) {
					const donutPercentNumber = getPercentage(donut);
					const donutColorIndicator = donut.querySelector<HTMLElement>(".animated-donut-percent");
					const donutColor = setColors(donutColorIndicator);
					donutWithRing.style.background = `conic-gradient(from 0deg, ${donutColor.start} 0%,${donutColor.end} ${donutPercentNumber}%,#00000000 ${donutPercentNumber}%)`;
				} else {
					const donutCardImage = donut.querySelector("animated-donut-image");
					if (donutCardImage) {
						donutCardImage.classList.add("animated-donut-image-static");
					}
				}
			});
			donutContainer.classList.add("animated-donuts-static");
		});
	}
};
